import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-message-type-label',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './message-type-label.component.html',
  styleUrls: ['./message-type-label.component.scss']
})
export class MessageTypeLabelComponent {
  @Input() messageType: string = '';

  get icon(): string {
    switch (this.messageType.toLowerCase()) {
      case 'email': return 'mail_outline';
      case 'sms': return 'message';
      case 'whatsapp': return 'whatsapp';
      default: return 'chat';
    }
  }

  get label(): string {
    const type = this.messageType.toLowerCase();
    switch (type) {
      case 'email':
      case 'correo':
        return 'Correo';
      case 'sms':
        return 'SMS';
      case 'whatsapp':
        return 'Whatsapp';
      default:
        return this.messageType || 'Chat';
    }
  }

  get isWhatsapp(): boolean {
    return this.messageType.toLowerCase() === 'whatsapp';
  }

  get cssClass(): string {
    const type = this.messageType.toLowerCase();
    switch (type) {
      case 'email':
      case 'correo':
        return 'email';
      case 'sms':
        return 'sms';
      case 'whatsapp':
        return 'whatsapp';
      default:
        return type;
    }
  }
}
